<template>
    <v-layout>
        <v-flex md2 ma-0>
            <LeftPanel v-bind:name="name" v-bind:photo="photo"/>
        </v-flex>

        <v-flex xs12 md10>
            <RightPanel :displayName="'showContacts'"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import firebase from 'firebase'
    import LeftPanel from '@/components/employee/partials/LeftEmployeePanel'
    import RightPanel from '@/components/employee/partials/RightEmployeePanel'

    export default {
        name: "EmployeeHome",
        components: {
            LeftPanel, RightPanel
        },
        data: () => ({
            photo: "",
            userId: "",
            name: "",
            email: ""
        }),
        created() {
            this.user = firebase.auth().currentUser;
            this.name = this.user.displayName;
            this.email = this.user.email;
            this.photo = this.user.photoURL;
            this.userId = this.user.uid;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/employee/EmployeeHome.vue